import { Box, Grid, Typography, useTheme } from "@mui/material";
import Card from "components/Card";
import NumberFormats from "components/NumberFormats";
import { DefaultUrlWeb } from "config/Configuration";
import React from "react";
import WrapperAction from "./Action";
import Status from "./Status";
import RemainingBar from "./RemainingBar";

function FixedBox({ fixedFundItem, handleShowDetails, handleShowAction }) {
  const theme = useTheme();

  return (
    <Card shadow={theme.shadows[1]} padding="16px 16px 16px 16px !important" maxHeight="initial">
      <Grid
        pb={1}
        container
        display="flex"
        flexDirection="row-reverse"
        alignItems="start"
      >
        <Grid item xs={2} display="flex" justifyContent="center">
          <img
            width="30px"
            src={DefaultUrlWeb + fixedFundItem?.coinImageUrl}
            alt={fixedFundItem?.name}
          />
        </Grid>

        <Grid item xs={10} pl={2}>
          <Grid container dir="ltr">
            <Grid item xs={6}>
              <Box
                py={1}
                display="flex"
                justifyContent="space-between"
                flexDirection="column"
                dir="ltr"
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Create Date:
                </Typography>
                <Box display="flex" flexDirection="column">
                  <Typography variant="h6" color="text.main">
                    {fixedFundItem?.date}
                  </Typography>
                  <Typography variant="h6" color="text.main">
                    {fixedFundItem?.time}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                py={1}
                flexDirection="column"
                display="flex"
                justifyContent="space-between"
                dir="ltr"
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Total:
                </Typography>
                <Box display="flex">
                  <Typography variant="h6" fontWeight={400} color="text.main">
                    <NumberFormats
                      displayType={"text"}
                      value={fixedFundItem?.total}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    {fixedFundItem?.nameCoin}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                py={1}
                flexDirection="column"
                display="flex"
                justifyContent="space-between"
                dir="ltr"
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Status:
                </Typography>

                <Box display="flex" alignItems="center">
                  <Status data={fixedFundItem} />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                flexDirection="column"
                py={1}
                display="flex"
                justifyContent="space-between"
                dir="ltr"
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Amount:
                </Typography>
                <Box display="flex">
                  <Typography variant="h6" fontWeight={400} color="text.main">
                    <NumberFormats
                      displayType={"text"}
                      value={fixedFundItem?.amount}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    {fixedFundItem?.nameCoin}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                py={1}
                flexDirection="column"
                display="flex"
                justifyContent="space-between"
                dir="ltr"
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Remaining Days:
                </Typography>
                <Box display="flex" flexDirection="column">
                  <RemainingBar data={fixedFundItem} />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                flexDirection="column"
                py={1}
                display="flex"
                justifyContent="space-between"
                dir="ltr"
              >
                <Typography variant="subtitle2" color="text.secondary">
                  Action:
                </Typography>

                <WrapperAction
                  data={fixedFundItem}
                  fixed={true}
                  handleShowDetails={handleShowDetails}
                  handleShowAction={handleShowAction}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

export default FixedBox;
